<template>
  <v-content>
    <v-container style="margin-top: 16px">

        <p class="text-justify">{{ $t('descripcionZBE1') }}</p>
        <p class="text-justify">{{ $t('descripcionZBE2') }}</p>
        <a href="https://www.zbe.barcelona">https://www.zbe.barcelona</a>

    </v-container>
  </v-content>
</template>

<script>
export default {
  name: "PaginaZBE",

  data: () => ({
  })
};
</script>
